var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { create } from "zustand";
var roundPortfolioAmount = function (value) { return Number(Math.max(value, 0).toFixed(8)); };
export var normalizePortfolioSymbol = function (symbol) {
    var normalized = (symbol !== null && symbol !== void 0 ? symbol : "").trim().toUpperCase();
    if (normalized === "WBNB") {
        return "BNB";
    }
    return normalized;
};
export var usePortfolioStore = create()(function (set) { return ({
    totalHoldings: 0,
    profileBalances: {},
    setTotalHoldings: function (value) { return set({ totalHoldings: value }); },
    initializeProfileBalances: function (coins) {
        return set(function (state) {
            var nextProfileBalances = __assign({}, state.profileBalances);
            var hasChanges = false;
            coins.forEach(function (coin) {
                var _a;
                var symbol = normalizePortfolioSymbol(coin.title);
                if (!symbol || symbol in nextProfileBalances) {
                    return;
                }
                nextProfileBalances[symbol] = (_a = coin.owned) !== null && _a !== void 0 ? _a : 0;
                hasChanges = true;
            });
            return hasChanges ? { profileBalances: nextProfileBalances } : state;
        });
    },
    setProfileBalance: function (symbol, amount) {
        return set(function (state) {
            var _a;
            var normalizedSymbol = normalizePortfolioSymbol(symbol);
            if (!normalizedSymbol) {
                return state;
            }
            return {
                profileBalances: __assign(__assign({}, state.profileBalances), (_a = {}, _a[normalizedSymbol] = roundPortfolioAmount(amount), _a)),
            };
        });
    },
    swapProfileBalances: function (_a) {
        var fromSymbol = _a.fromSymbol, toSymbol = _a.toSymbol, fromAmount = _a.fromAmount, toAmount = _a.toAmount;
        return set(function (state) {
            var _a;
            var _b, _c;
            var normalizedFromSymbol = normalizePortfolioSymbol(fromSymbol);
            var normalizedToSymbol = normalizePortfolioSymbol(toSymbol);
            if (!normalizedFromSymbol ||
                !normalizedToSymbol ||
                normalizedFromSymbol === normalizedToSymbol ||
                fromAmount <= 0 ||
                toAmount <= 0) {
                return state;
            }
            var availableFromBalance = (_b = state.profileBalances[normalizedFromSymbol]) !== null && _b !== void 0 ? _b : 0;
            if (availableFromBalance + 1e-8 < fromAmount) {
                return state;
            }
            return {
                profileBalances: __assign(__assign({}, state.profileBalances), (_a = {}, _a[normalizedFromSymbol] = roundPortfolioAmount(availableFromBalance - fromAmount), _a[normalizedToSymbol] = roundPortfolioAmount(((_c = state.profileBalances[normalizedToSymbol]) !== null && _c !== void 0 ? _c : 0) + toAmount), _a)),
            };
        });
    },
    recalcTotalHoldings: function (_a) {
        var coins = _a.coins, balances = _a.balances;
        return set(function (state) {
            var totalHoldings = coins.reduce(function (sum, coin) {
                var _a, _b, _c, _d, _e;
                var symbol = normalizePortfolioSymbol(coin.title);
                var owned = (_b = (_a = state.profileBalances[symbol]) !== null && _a !== void 0 ? _a : coin.owned) !== null && _b !== void 0 ? _b : 0;
                var onWallet = symbol && symbol in balances ? ((_c = balances[symbol]) !== null && _c !== void 0 ? _c : 0) : 0;
                var price = coin.price || ((_e = (_d = coin.chartData) === null || _d === void 0 ? void 0 : _d.at(-1)) === null || _e === void 0 ? void 0 : _e.price) || 0;
                return sum + (owned + onWallet) * price;
            }, 0);
            return { totalHoldings: totalHoldings };
        });
    },
}); });
